var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"text-decoration-none text-base-white p-x-12 p-y-9 radius-8 d-flex justify-content-center align-items-center gap-10 cursor-pointer bg-primary-500",attrs:{"to":{ name: 'loyaltyProgram' }}},[_c('Boost'),_c('span',{staticClass:"p-base-medium"},[_vm._v(_vm._s(_vm.$t("labels.loyaltyProgram")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }